import * as React from "react";

export const IconTrash = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0.833333 13.3333C0.833333 14.25 1.58333 15 2.5 15L9.16667 15C10.0833 15 10.8333 14.25 10.8333 13.3333L10.8333 3.33333L0.833333 3.33333L0.833333 13.3333ZM11.6667 0.833333L8.75 0.833333L7.91667 0L3.75 0L2.91667 0.833333L0 0.833333L0 2.5L11.6667 2.5V0.833333Z"
      fill={props?.color ?? "#E57373"}
    />
  </svg>
);
